export interface BankHolidays {
  events: BankHoliday[];
}

export interface BankHoliday {
  title: string;
  date: string;
  notes: string;
  bunting: boolean;
}

export const bankHolidays: BankHolidays = {
  events: [
    { title: 'New Year’s Day', date: '2018-01-01', notes: '', bunting: true },
    { title: 'Good Friday', date: '2018-03-30', notes: '', bunting: false },
    { title: 'Easter Monday', date: '2018-04-02', notes: '', bunting: true },
    { title: 'Early May bank holiday', date: '2018-05-07', notes: '', bunting: true },
    { title: 'Spring bank holiday', date: '2018-05-28', notes: '', bunting: true },
    { title: 'Summer bank holiday', date: '2018-08-27', notes: '', bunting: true },
    { title: 'Christmas Day', date: '2018-12-25', notes: '', bunting: true },
    { title: 'Boxing Day', date: '2018-12-26', notes: '', bunting: true },
    { title: 'New Year’s Day', date: '2019-01-01', notes: '', bunting: true },
    { title: 'Good Friday', date: '2019-04-19', notes: '', bunting: false },
    { title: 'Easter Monday', date: '2019-04-22', notes: '', bunting: true },
    { title: 'Early May bank holiday', date: '2019-05-06', notes: '', bunting: true },
    { title: 'Spring bank holiday', date: '2019-05-27', notes: '', bunting: true },
    { title: 'Summer bank holiday', date: '2019-08-26', notes: '', bunting: true },
    { title: 'Christmas Day', date: '2019-12-25', notes: '', bunting: true },
    { title: 'Boxing Day', date: '2019-12-26', notes: '', bunting: true },
    { title: 'New Year’s Day', date: '2020-01-01', notes: '', bunting: true },
    { title: 'Good Friday', date: '2020-04-10', notes: '', bunting: false },
    { title: 'Easter Monday', date: '2020-04-13', notes: '', bunting: false },
    { title: 'Early May bank holiday (VE day)', date: '2020-05-08', notes: '', bunting: true },
    { title: 'Spring bank holiday', date: '2020-05-25', notes: '', bunting: true },
    { title: 'Summer bank holiday', date: '2020-08-31', notes: '', bunting: true },
    { title: 'Christmas Day', date: '2020-12-25', notes: '', bunting: true },
    { title: 'Boxing Day', date: '2020-12-28', notes: 'Substitute day', bunting: true },
    { title: 'New Year’s Day', date: '2021-01-01', notes: '', bunting: true },
    { title: 'Good Friday', date: '2021-04-02', notes: '', bunting: false },
    { title: 'Easter Monday', date: '2021-04-05', notes: '', bunting: true },
    { title: 'Early May bank holiday', date: '2021-05-03', notes: '', bunting: true },
    { title: 'Spring bank holiday', date: '2021-05-31', notes: '', bunting: true },
    { title: 'Summer bank holiday', date: '2021-08-30', notes: '', bunting: true },
    { title: 'Christmas Day', date: '2021-12-27', notes: 'Substitute day', bunting: true },
    { title: 'Boxing Day', date: '2021-12-28', notes: 'Substitute day', bunting: true },
    { title: 'New Year’s Day', date: '2022-01-03', notes: 'Substitute day', bunting: true },
    { title: 'Good Friday', date: '2022-04-15', notes: '', bunting: false },
    { title: 'Easter Monday', date: '2022-04-18', notes: '', bunting: true },
    { title: 'Early May bank holiday', date: '2022-05-02', notes: '', bunting: true },
    { title: 'Spring bank holiday', date: '2022-06-02', notes: '', bunting: true },
    { title: 'Platinum Jubilee bank holiday', date: '2022-06-03', notes: '', bunting: true },
    { title: 'Summer bank holiday', date: '2022-08-29', notes: '', bunting: true },
    {
      title: 'Bank Holiday for the State Funeral of Queen Elizabeth II',
      date: '2022-09-19',
      notes: '',
      bunting: false
    },
    { title: 'Boxing Day', date: '2022-12-26', notes: '', bunting: true },
    { title: 'Christmas Day', date: '2022-12-27', notes: 'Substitute day', bunting: true },
    { title: 'New Year’s Day', date: '2023-01-02', notes: 'Substitute day', bunting: true },
    { title: 'Good Friday', date: '2023-04-07', notes: '', bunting: false },
    { title: 'Easter Monday', date: '2023-04-10', notes: '', bunting: true },
    { title: 'Early May bank holiday', date: '2023-05-01', notes: '', bunting: true },
    {
      title: 'Bank holiday for the coronation of King Charles III',
      date: '2023-05-08',
      notes: '',
      bunting: true
    },
    { title: 'Spring bank holiday', date: '2023-05-29', notes: '', bunting: true },
    { title: 'Summer bank holiday', date: '2023-08-28', notes: '', bunting: true },
    { title: 'Christmas Day', date: '2023-12-25', notes: '', bunting: true },
    { title: 'Boxing Day', date: '2023-12-26', notes: '', bunting: true },
    { title: 'New Year’s Day', date: '2024-01-01', notes: '', bunting: true },
    { title: 'Good Friday', date: '2024-03-29', notes: '', bunting: false },
    { title: 'Easter Monday', date: '2024-04-01', notes: '', bunting: true },
    { title: 'Early May bank holiday', date: '2024-05-06', notes: '', bunting: true },
    { title: 'Spring bank holiday', date: '2024-05-27', notes: '', bunting: true },
    { title: 'Summer bank holiday', date: '2024-08-26', notes: '', bunting: true },
    { title: 'Christmas Day', date: '2024-12-25', notes: '', bunting: true },
    { title: 'Boxing Day', date: '2024-12-26', notes: '', bunting: true },
    { title: 'New Year’s Day', date: '2025-01-01', notes: '', bunting: true },
    { title: 'Good Friday', date: '2025-04-18', notes: '', bunting: false },
    { title: 'Easter Monday', date: '2025-04-21', notes: '', bunting: true },
    { title: 'Early May bank holiday', date: '2025-05-05', notes: '', bunting: true },
    { title: 'Spring bank holiday', date: '2025-05-26', notes: '', bunting: true },
    { title: 'Summer bank holiday', date: '2025-08-25', notes: '', bunting: true },
    { title: 'Christmas Day', date: '2025-12-25', notes: '', bunting: true },
    { title: 'Boxing Day', date: '2025-12-26', notes: '', bunting: true }
  ]
};
